import { Pipe, PipeTransform } from '@angular/core';
import { BillingFrequency } from '../../core/types';
import { formatDisplayPrice } from '../../core/utils/pipe-utils';

@Pipe({ standalone: true, name: 'price' })
export class PricePipe implements PipeTransform {
  transform(
    value: any,
    currency: string,
    billingFrequency?: BillingFrequency,
    isCents = true,
    translateZero = true,
    displaySymbol = true,
  ): any {
    return formatDisplayPrice(value, currency, billingFrequency, isCents, translateZero, displaySymbol);
  }
}
